import { showErrorResponse } from "../../app/utils/common/Functions";
import { showSuccessToast } from "../../app/utils/common/Toast";
import { LEAVE_APPROVE_PENDING_REFRESH_EVENT } from "../../app/utils/constants/apiConstant";
import {
    addAdminHrLeaveNoteAPI,
    addLeaveCommentAPI,
    createLeaveRequestAPI,
    createWfhForEmployeeAPI,
    getAllLeavesAPI,
    getUserLeaveRequestAPI,
    revokeApprovedLeaveAPI,
    reviewCancelApprovedLeaveAPI,
    sendEmailForLeaveRequestAPI
} from "../Apis/leaveApi";

function dispatchLeaveApprovePendingRefresh() {
    if (typeof window !== "undefined") {
        window.dispatchEvent(new CustomEvent(LEAVE_APPROVE_PENDING_REFRESH_EVENT));
    }
}

export const leaveApproveReducer = (builder) => {
    builder
        .addCase(getAllLeavesAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(getAllLeavesAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.pagination = action.payload.data.pagination;
            state.allLeaves = action.payload.data.leaveRequests;
            state.isAllLeaveUpdated = false;
            if (action.payload.data.statusCounts) {
                state.statusCounts = action.payload.data.statusCounts;
            }
        })
        .addCase(getAllLeavesAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })

        .addCase(revokeApprovedLeaveAPI.pending, (state) => {
            state.loading = true;
        })
        .addCase(revokeApprovedLeaveAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.isAllLeaveUpdated = true;
            showSuccessToast(action.payload?.message || "Leave cancelled successfully");
            dispatchLeaveApprovePendingRefresh();
        })
        .addCase(revokeApprovedLeaveAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(reviewCancelApprovedLeaveAPI.pending, (state) => {
            state.loading = true;
        })
        .addCase(reviewCancelApprovedLeaveAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.isAllLeaveUpdated = true;
            showSuccessToast(action.payload?.message || "Cancellation decision saved");
            dispatchLeaveApprovePendingRefresh();
        })
        .addCase(reviewCancelApprovedLeaveAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(addAdminHrLeaveNoteAPI.pending, (state) => {
            state.loading = true;
        })
        .addCase(addAdminHrLeaveNoteAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.isAllLeaveUpdated = true;
            showSuccessToast(action.payload?.message || "Note sent to HR");
            dispatchLeaveApprovePendingRefresh();
        })
        .addCase(addAdminHrLeaveNoteAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(addLeaveCommentAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(addLeaveCommentAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.isAllLeaveUpdated = true;
            showSuccessToast(action.payload?.message || "Leave comment added successfully");
            dispatchLeaveApprovePendingRefresh();
        })
        .addCase(addLeaveCommentAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(sendEmailForLeaveRequestAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(sendEmailForLeaveRequestAPI.fulfilled, (state, action) => {
            state.loading = false;
            showSuccessToast("Leave email sent successfully");
            state.isAllLeaveUpdated = true;

        })
        .addCase(sendEmailForLeaveRequestAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(createWfhForEmployeeAPI.pending, (state) => {
            state.loading = true;
        })
        .addCase(createWfhForEmployeeAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.isAllLeaveUpdated = true;
            showSuccessToast(action.payload?.message || "Work from home assigned to employee");
            dispatchLeaveApprovePendingRefresh();
        })
        .addCase(createWfhForEmployeeAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })

};
